import { render, staticRenderFns } from "./TicketTypeEditor.vue?vue&type=template&id=3d8c2b92&scoped=true&"
import script from "./TicketTypeEditor.vue?vue&type=script&lang=js&"
export * from "./TicketTypeEditor.vue?vue&type=script&lang=js&"
import style0 from "./TicketTypeEditor.vue?vue&type=style&index=0&id=3d8c2b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8c2b92",
  null
  
)

export default component.exports